import { ReactComponent as ProgressActivity } from '../../../../assets/icons/progress-activity.svg';

export { ProgressActivity };
